// OPTIONS
export const IS_FINANCED = [
  {
    value: true,
    label: 'Bank'
  },
  {
    value: false,
    label: 'Customer (Cash)'
  }
];
export const DSL_CUSTOMER_SOURCE_ID = [
  {
    value: 1,
    label: 'Personal Check'
  },
  {
    value: 2,
    label: 'Customer Bank'
  },
  {
    value: 3,
    label: 'Other'
  }
];
